import React from "react"
import { useSyncExternalStore } from "react"
import { Link } from "gatsby"
import {
  subscribe,
  getOrder,
  getServerOrder,
  sortIcons,
} from "../utils/iconOrder"
import "../styles/desktop-icons.css"

const Folder = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path
      d="M3 8a2 2 0 0 1 2-2h7l3 3h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      fill="currentColor"
      opacity="0.25"
    />
    <path
      d="M3 8a2 2 0 0 1 2-2h7l3 3h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
)

const Camera = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="9"
      width="26"
      height="18"
      rx="2"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="9"
      width="26"
      height="18"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M11 9l2-4h6l2 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <circle
      cx="16"
      cy="18"
      r="5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
)

const Film = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="6"
      width="26"
      height="20"
      rx="2"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="6"
      width="26"
      height="20"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M9 6v20M23 6v20M3 16h26"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
)

const Terminal = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="5"
      width="26"
      height="22"
      rx="2"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="5"
      width="26"
      height="22"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M8 12l4 4-4 4M16 20h8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Pencil = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path
      d="M5 27l1.5-6L21 6.5a2.5 2.5 0 0 1 3.5 0l1 1a2.5 2.5 0 0 1 0 3.5L11 25.5z"
      fill="currentColor"
      opacity="0.25"
    />
    <path
      d="M5 27l1.5-6L21 6.5a2.5 2.5 0 0 1 3.5 0l1 1a2.5 2.5 0 0 1 0 3.5L11 25.5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
)

const Orbit = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="4" fill="currentColor" opacity="0.4" />
    <ellipse
      cx="16"
      cy="16"
      rx="13"
      ry="6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      transform="rotate(-25 16 16)"
    />
    <circle cx="27" cy="10" r="2" fill="currentColor" />
  </svg>
)

const SunCloud = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="12" cy="11" r="4.5" fill="currentColor" opacity="0.3" />
    <circle
      cx="12"
      cy="11"
      r="4.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M12 3.5v2M3.5 11h2M6.9 5.9l1.4 1.4M17.1 5.9l-1.4 1.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M10 26h13a5.5 5.5 0 0 0 .6-11A8 8 0 0 0 8.4 17.2 4.9 4.9 0 0 0 10 26z"
      fill="currentColor"
      opacity="0.25"
    />
    <path
      d="M10 26h13a5.5 5.5 0 0 0 .6-11A8 8 0 0 0 8.4 17.2 4.9 4.9 0 0 0 10 26z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
)

const Person = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="11" r="5" fill="currentColor" opacity="0.25" />
    <circle
      cx="16"
      cy="11"
      r="5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M6 27a10 10 0 0 1 20 0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
)

const Ruler = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="2"
      y="11"
      width="28"
      height="10"
      rx="1.5"
      fill="currentColor"
      opacity="0.25"
      transform="rotate(-20 16 16)"
    />
    <rect
      x="2"
      y="11"
      width="28"
      height="10"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      transform="rotate(-20 16 16)"
    />
    <path
      d="M8 12.5v3M13 10.5v4.5M18 8.5v3M23 6.5v4.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      transform="rotate(-20 16 16)"
    />
  </svg>
)

/* A cigarette with a line through it. Legible at 32px in a way a lung or a
   pair of crossed-out lips is not. */
const NoSmoking = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="12" fill="currentColor" opacity="0.2" />
    <circle
      cx="16"
      cy="16"
      r="12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <rect x="8" y="14.5" width="14" height="3.5" rx="0.6" fill="currentColor" />
    <path
      d="M7.5 7.5l17 17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
)

const Wallet = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="8"
      width="26"
      height="18"
      rx="2.5"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="8"
      width="26"
      height="18"
      rx="2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M3 13h18a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <circle cx="22.5" cy="17" r="1.6" fill="currentColor" />
  </svg>
)

const Braces = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="5"
      width="26"
      height="22"
      rx="2"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="5"
      width="26"
      height="22"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M13 11c-2 0-2 4-3.5 5 1.5 1 1.5 5 3.5 5M19 11c2 0 2 4 3.5 5-1.5 1-1.5 5-3.5 5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
)

/* Two documents offset, with a plus and a minus: a comparison, not a copy. */
const Compare = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <rect
      x="3"
      y="4"
      width="15"
      height="20"
      rx="2"
      fill="currentColor"
      opacity="0.25"
    />
    <rect
      x="3"
      y="4"
      width="15"
      height="20"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <rect
      x="14"
      y="8"
      width="15"
      height="20"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M7 14h6M18 18h6M21 15v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
)

/* The Vulcan salute reads instantly and none of the other four throws do at
   32px, so the whole game gets to be Spock's hand. */
const Salute = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path
      d="M7 30v-7c0-2 .5-3.5 1.5-5L7 12a1.8 1.8 0 0 1 3-2l2 3.5V4a1.8 1.8 0 0 1 3.6 0v7.5L16 4a1.8 1.8 0 0 1 3.6 0l.4 7.5L21 5a1.8 1.8 0 0 1 3.5.6L24 18c-.4 5-2.5 8-6 12z"
      fill="currentColor"
      opacity="0.25"
    />
    <path
      d="M7 30v-7c0-2 .5-3.5 1.5-5L7 12a1.8 1.8 0 0 1 3-2l2 3.5V4a1.8 1.8 0 0 1 3.6 0v7.5L16 4a1.8 1.8 0 0 1 3.6 0l.4 7.5L21 5a1.8 1.8 0 0 1 3.5.6L24 18c-.4 5-2.5 8-6 12z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
)

const SpeakerWaves = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path d="M4 12h5l6-5v18l-6-5H4z" fill="currentColor" opacity="0.3" />
    <path
      d="M4 12h5l6-5v18l-6-5H4z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M19 12a6 6 0 0 1 0 8M23 8.5a11 11 0 0 1 0 15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
)

const Warp = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="12" fill="currentColor" opacity="0.18" />
    <circle cx="16" cy="16" r="2.4" fill="currentColor" />
    <path
      d="M16 16L27 9M16 16L27 23M16 16L5 9M16 16L5 23M16 16v-9M16 16v9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.85"
    />
  </svg>
)

/* Lines of text lying down into a vanishing point: the crawl, at 32px. */
const Crawl = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path d="M4 27h24l-6-18H10z" fill="currentColor" opacity="0.25" />
    <path
      d="M4 27h24l-6-18H10z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M11.6 13h8.8M10.4 17h11.2M9 21h14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

const Lander = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path d="M16 4l6 12H10z" fill="currentColor" opacity="0.3" />
    <path
      d="M16 4l6 12H10z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M12 16l-4 7M20 16l4 7"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M4 27h24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.6"
    />
  </svg>
)

const Car = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path
      d="M5 20v-4l2.5-6A2 2 0 0 1 9.4 8.7h13.2a2 2 0 0 1 1.9 1.3L27 16v4z"
      fill="currentColor"
      opacity="0.28"
    />
    <path
      d="M5 20v-4l2.5-6A2 2 0 0 1 9.4 8.7h13.2a2 2 0 0 1 1.9 1.3L27 16v4z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M5 16h22" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <circle
      cx="10"
      cy="21.5"
      r="2.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <circle
      cx="22"
      cy="21.5"
      r="2.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
  </svg>
)

/* A bug with too many legs. Not the film's gremlin: this one has to read at
   32px and say "something small is loose in your page". */
const Bug = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <ellipse cx="16" cy="18" rx="7" ry="9" fill="currentColor" opacity="0.28" />
    <ellipse
      cx="16"
      cy="18"
      rx="7"
      ry="9"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M9 13L4 9M23 13l5-4M9 18H3M23 18h6M9 23l-5 4M23 23l5 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13 7.5l1.5 2.5M19 7.5L17.5 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

/* `tint` is only used by the phone home screen, where an app icon is a solid
   coloured tile rather than an outline on the wallpaper. `kind` is only used
   by the desktop's sort-by-kind, which groups the post folders above the
   programs above the plain pages. `desktopOnly` keeps an app off the
   phone home screen entirely. */
export const ICONS = [
  { to: "/posts", label: "All Posts", kind: "folder", Icon: Folder, tint: "#2f7cf6, #1d4fd8" },
  { to: "/photos", label: "Photos", kind: "folder", Icon: Camera, tint: "#f7595b, #c81e5b" },
  {
    to: "/posts?category=video",
    label: "Video", kind: "folder",
    Icon: Film,
    tint: "#8b5cf6, #5b21b6",
  },
  {
    to: "/terminal",
    label: "Terminal",
    kind: "app",
    Icon: Terminal,
    tint: "#2ea86a, #12603c",
    /* A shell is a keyboard, and a phone has not got one. It stays on the
       desktop and off the home screen rather than being a tile that opens
       something you cannot type into. */
    desktopOnly: true,
  },
  {
    to: "/whiteboard",
    label: "Whiteboard", kind: "app",
    Icon: Pencil,
    tint: "#f5a623, #e0651a",
  },
  {
    to: "/neo-tracker",
    label: "NEO Tracker", kind: "app",
    Icon: Orbit,
    tint: "#12b5a6, #0b7f83",
  },
  {
    to: "/weather",
    label: "Weather", kind: "app",
    Icon: SunCloud,
    tint: "#5fb8f0, #2168b8",
  },
  {
    to: "/pixel-to-rem",
    label: "Pixels to Rem", kind: "app",
    Icon: Ruler,
    tint: "#9aa0ac, #5b616d",
  },
  {
    to: "/quit-smoking",
    label: "Quit Smoking", kind: "app",
    Icon: NoSmoking,
    tint: "#e0574f, #96231d",
  },
  { to: "/budget", label: "Budget", kind: "app", Icon: Wallet, tint: "#3fa971, #1c6d45" },
  {
    to: "/json-schema",
    label: "Schema Generator", kind: "app",
    Icon: Braces,
    tint: "#c98a2e, #8a5a12",
  },
  {
    to: "/json-diff",
    label: "JSON Deep Diff", kind: "app",
    Icon: Compare,
    tint: "#7a6ff0, #3f34a8",
  },
  {
    to: "/rpsls",
    label: "RPS Lizard Spock", kind: "app",
    Icon: Salute,
    tint: "#d9a441, #96651a",
  },
  {
    to: "/text-to-speech",
    label: "Text to Speech", kind: "app",
    Icon: SpeakerWaves,
    tint: "#4fb0c6, #1f6b80",
  },
  { to: "/warp", label: "Warp", kind: "app", Icon: Warp, tint: "#3d7fd6, #16306b" },
  { to: "/crawl", label: "Crawl", kind: "app", Icon: Crawl, tint: "#e0b42c, #8a6a0c" },
  {
    to: "/lunar-lander",
    label: "Lunar Lander", kind: "app",
    Icon: Lander,
    tint: "#5f6b7d, #262e3b",
  },
  {
    to: "/driving-sim",
    label: "Parking Lot", kind: "app",
    Icon: Car,
    tint: "#d94f3d, #8a2418",
  },
  { to: "/gremlins", label: "Gremlins", kind: "app", Icon: Bug, tint: "#6aa84f, #33521f" },
  { to: "/about", label: "About Me", kind: "page", Icon: Person, tint: "#4ba3f0, #2563a8" },
]

/**
 * The icon grid on its own.
 *
 * Shared because the shell draws it under every open window, the way a real
 * desktop keeps its icons visible behind an application. The home route also
 * renders it, wrapped in the home screen's own heading and indicator.
 */
const IconGrid = () => {
  /* Subscribed rather than passed down: the home route and the shell's icon
     layer both draw this and share no parent that re-renders when the order
     changes. */
  const order = useSyncExternalStore(subscribe, getOrder, getServerOrder)
  const icons = sortIcons(ICONS, order)

  return (
    <ul className="desktop-icon-grid">
      {icons.map(({ to, label, Icon }) => (
        <li key={label}>
          <Link to={to} className="desktop-icon">
            <span className="desktop-icon-art">
              <Icon />
            </span>
            <span className="desktop-icon-label">{label}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default IconGrid
